<template>
  <div id="onlineschoollist" ref="anchor">
    <v-container :class="'info-detail-sbs'">
          <v-layout row wrap>
        <v-flex x12>
          <v-btn small icon dark @click="$router.push('/video-pembelajaran')">
            <v-icon>arrow_back</v-icon>
          </v-btn>
        </v-flex>
        <v-flex xs10 offset-xs1>
          <span class="white--text">Mata Pelajaran</span>
          <!-- <h2 class="white--text">{{ data.tryout_name}}</h2>   -->
        </v-flex>
        <v-flex xs10 offset-xs1>
          <h2 class="white--text">{{subject}}</h2>
        </v-flex>
      </v-layout>
    </v-container>

    <v-layout row wrap>
      <v-flex xs12>
          <search-video-component ref="searchvideo"></search-video-component>
      </v-flex>
    </v-layout>

    <v-container>
      <v-layout row wrap>
        <v-flex xs12>
          <p style="font-weight:bold; color:#33aadb;">Bab </p>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs12 style="display:flex; justify-content:center;">
          <v-progress-circular
            v-if="loader"
            indeterminate
            :size="30"
            color="primary"
          ></v-progress-circular>
        </v-flex>
      </v-layout>
      <v-card v-for="(item,index) in babs" v-bind:key="index"  style="margin-bottom:1em;cursor:pointer;" @click="toVideo(item)">
        <v-container>
          <v-layout row wrap>
            <v-flex xs10>
              <h3>{{item.title}}</h3>
              <p color="grey lighten-1" style="margin:0;">{{item.total_video_count}} Video dan {{item.subbab_count}} sub bab</p>
            </v-flex>
            <v-flex xs2 style="display:flex;align-items:center;">
              <v-icon color="grey lighten-1">chevron_right</v-icon>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>

      <infinite-loading v-if="babs.length" @infinite="fetchBab">
            <div slot="spinner"><v-progress-circular
              :size="25"
              color="primary"
              indeterminate
            ></v-progress-circular></div>
            <div slot="no-more">&nbsp;</div>
            <div slot="no-results">&nbsp;</div>
          </infinite-loading>
    </v-container>

  </div>
</template>

<style>
  .filter {
    position: fixed;
    bottom:0;
    left: 0;
    right: 0;
    width: 100%;
    display:flex;
    justify-content:center;
    margin-bottom: 10px;
  }
  .filter-btn {
    padding: 15px;
    display:flex;
    align-items:center;
    box-shadow:0px 3px 5px 0px rgba(0,0,0,0.75);
  }
  .list-filter {
    padding:15px; background-color:#f7f7f7;
  }
  .video-title {
    margin-top: 10px; padding-left: 10px;
  }
  .duration {
    background: black; color: white; position:absolute; right: 5px; bottom: 10px; padding: 2px; border-radius: 3px;
  }
  .video-card {
    margin:20px;margin-top: 10px; margin-bottom:0px; padding:10px;border-radius: 8px;
  }
  .v-text-field__details {
    display:none;
  }
</style>

<script>
// import { mapGetters } from 'vuex'
import InfiniteLoading from 'vue-infinite-loading'
import SearchVideoComponent from '../../components/SearchVideo/SearchVideoComponent.vue'
// import moment from 'moment/src/moment'
/* eslint-disable */
export default {
  name: 'online-school-list-feature-component',
  data () {
    return {
      subject: null,
      babs: [],
      page: 1,
      loader: false
    }
  },
  components: {
    'search-video-component': SearchVideoComponent,
    InfiniteLoading
  },
  watch: {
    bottom(bottom) {
      if (bottom) {
        this.fetchData()
      }
    }
  },
  methods: {
    fetchBab($state) {
      setTimeout(() => {
        this.subject = this.$store.state.video.video_mapel.nama

        var param = {
          mapel_id: this.$route.params.id,
          interest: this.$store.state.video.video_mapel.interest,
          page: this.page
        }
        this.$store.dispatch('funcGetBabList', param).then((response) => {
          if (response.data.length > 0) {
            this.page += 1
            var data = response.data
            for(var i=0; i < response.data.length; i++){
              if(data[i].total_video_count != 0) this.babs.push(data[i])
            }
            // this.babs = response.data
            this.loader = false
            $state.loaded()
          } else {
            this.loader = false
            $state.complete()
          }
        }).catch(err => {
          if(err) console.log(err)
        })
      }, 500)
    },
    toVideo(data) {
      this.$store.commit('mutVideoBab', data)
      this.$router.push('/video/' + this.$route.params.id + '/bab/'+ data.id )
    },
  },
  mounted(){
    if(this.$route.query.sv) {
      this.$refs.searchvideo.triggerChildFunc()
    }
    this.loader = true
    this.fetchBab()
  }
}
</script>
